import React from "react";
import { Box, Typography } from "@mui/material";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "#333",
        color: "#fff",
        padding: "20px",
        display: "flex",
        flexDirection: { xs: "row-reverse", sm: "row" }, // Reverse on mobile
        alignItems: "center",
        justifyContent: "space-between", // Space between text and logo
        textAlign: "left", // Always left-align text
      }}
      aria-label="Site Footer"
    >
      {/* Text Section */}
      <Box>
        <Typography variant="body2" sx={{ marginBottom: "10px" }}>
          Your Trusted Grooming Destination Since 2009.
        </Typography>
        <Typography variant="body2">
          &copy; {new Date().getFullYear()} Evan Barbers. All Rights Reserved.
        </Typography>
      </Box>
      {/* Logo Section */}
      <Box
        component="img"
        src="/evanbarbers/logo.webp"
        alt="Evan Barbers Logo"
        sx={{
          width: 50,
          height: 50,
          objectFit: "contain",
          marginLeft: { xs: "10px", sm: "0" }, // Adjust spacing on mobile
        }}
      />
    </Box>
  );
};

export default Footer;
